import { OktaAuth } from '@okta/okta-auth-js';

/**
 * Application constants.
 * @type {import("../types").AppConstants}
 */
export const Constants = {
  AppName: 'Equipment Action Portal',
  PostLogoutRoute: '/',
};

/**
 * Okta configuration.
 * @type {import("../types").OktaConfig}
 */
export const OktaConfig = {
  issuer: window.REACT_APP_OKTA_ISSUER ?? process.env.REACT_APP_OKTA_ISSUER ?? '',
  clientId: window.REACT_APP_OKTA_CLIENTID ?? process.env.REACT_APP_OKTA_CLIENTID ?? '',
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'ApiGw.account',
    'ApiGw.thrive',
    'ApiGw.appl-user',
    'ApiGw.app-analytics',
    'ApiGw.teammembers',
    'ApiGw.org-management',
    'ApiGw.inv-mgmt',
  ],
  pkce: true,
  disableHttpsCheck: window.OKTA_TESTING_DISABLEHTTPSCHECK || false,
  postLogoutRedirectUri: `${window.location.origin}/logout`,
};

/**
 * Shared OktaAuth instance — used by both App.jsx (Security provider) and
 * apolloClient.js (auth link) so GraphQL requests always carry a valid token.
 */
export const oktaAuth = new OktaAuth(OktaConfig);

/**
 * EBS instance configuration.
 * @type {import("../types").EBSInstance[]} EBSInstances
 */
export const ebsInstances = [
  { name: 'DEV', instanceID: 'EBSDEV' },
  { name: 'DEV2', instanceID: 'EBSDEV2' },
  { name: 'DEV3', instanceID: 'EBSDEV3' },
  { name: 'DEV4', instanceID: 'EBSDEV4' },
  { name: 'DEV5', instanceID: 'EBSDEV5' },
  { name: 'DEV6', instanceID: 'EBSDEV6' },
];

export const isDev = window.REACT_APP_API_URL?.includes('apidev');
